<template>
    <div class="cardGeo">
        <div class="shadow-none relative card">
            <div class="header flex items-center justify-between">
                <div>
                    <div class="header__count">{{dataCard.total}}</div>
                    <div v-if="dataCard.geo && dataCard.geo !== 'total'">{{ dataCard.geo }} {{$t('global.Leads').toLowerCase()}}</div>
                    <div v-else>{{ $t('global.totalLeads') }}</div>
                </div>
                <div>
                    <div class="header__global">
                        <vs-icon v-if="!dataCard.geo" color="primary" class="block pr-1" size="small" v-bind="$iconData('icon-globe', 'fi-rr-globe')"/>
                        <img width="25" class="block" v-else :src="'../' + lang(dataCard.geo).flag" alt="">
                    </div>
                </div>
            </div>
            <div class="content p-4">
                <div v-for="(value, index) in sortedListOfKeys" :key="index">
                    <div class="flex justify-between items-center">
                        <div class="flex items-center">
                            <vs-icon class="pr-1" color="primary" v-bind="$iconData('icon-folder-plus', 'fi-rr-add-folder')"/>
                            <span>{{createName(value)}}</span>
                        </div>
                        <b>{{ dataCard[value] ? dataCard[value] : 0 }}</b>
                    </div>
                    <vs-divider />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getLanguages, strUpp} from '@/utils/utils'

export default {
    props: {
        dataCard: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    data() {
        return {
            sortedListOfKeys: ['deposits', 'post_deposits', 'supplements', 'lights', 'hold']
        }
    },

    methods: {
        lang(iso) {
            return getLanguages(iso)
        },

        createName(name) {
            return this.$t(`global.${strUpp(name)}`)
        }
    }
}
</script>

<style lang="scss">
    .cardGeo {
        .title {
            font-style: normal;
            font-weight: normal;
            font-size: 19px;
            line-height: 17px;
            padding: 20px;
            color: #000000;
            border-bottom: 1px solid #E2E2E2;
        }

        .card {
            background: #ffffff;
            border-radius: 8px;
        }

        .col {
            padding-right: 1rem;
            padding-bottom: 1rem;

            &:nth-child(5n) {
                padding-right: 0;
            }
        }

        .header {
            border-bottom: 1px solid #E2E2E2;
            padding: 20px;

            &__count {
                font-style: normal;
                font-weight: bold;
                font-size: 24px;
            }

            &__global {
                background: #EAE8FD;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
</style>
